export const MODULE = 'OVRS';

export const GET_TRANSACTION = `${MODULE}/get_transaction`;
export const APPROVE_TRANSACTION = `${MODULE}/approve_transaction`;
export const UPDATE_TRANSACTION = `${MODULE}/update_transaction`;
export const SHOW_TRANSACTION = `${MODULE}/show_transaction`;
export const START_ASSESSMENT = `${MODULE}/start_assessment`;
export const GET_SETTINGS = `${MODULE}/get_settings`;
export const UPDATE_TEST_STATUS = `${MODULE}/update_health_status`;
export const GET_BIRTH_ARCHIVE = `${MODULE}/get_birth_certificates_arhive`;
export const GET_PHOTO = `${MODULE}/getPhoto`;
export const ASSESS_RECEIPT = `${MODULE}/assess_receipt`;
export const EDIT_VIOLATIONS = `${MODULE}/edit_violations`;
export const EDIT_SINGLE_VIOLATIONS = `${MODULE}/edit_single_violations`;
export const CREATE_VIOLATION = `${MODULE}/create_violation`;
export const GET_VIOLATION_MATRIX_LIST = `${MODULE}/get_violation_matrix_list`;
export const GET_MATRIX_INFO = `${MODULE}/get_matrix_info`;
export const GET_OFFICERS = `${MODULE}/get_officers`;
export const CREATE_OVRS = `${MODULE}/create_ovrs`;
export const APPROVE_VIOLATOR = `${MODULE}/approve_violator`;
export const GENERATE_TRANSMITTAL = `${MODULE}/generate_transmittal`;
export const DISAPPROVE_VIOLATOR = `${MODULE}/disapprove_violator`;

export const FORM_DATA = {
  first_name: '',
  last_name: '',
  middle_name: '',
  birth_date: '',
  extension_name: '',
  ovr_number: '',
  mobile_number: '',
  region_code: '',
  province_code: '',
  municipality_code: '',
  barangay_code: '',
  driver_license_number: '',
  driver_license_validity_date_from: '',
  driver_license_validity_date_to: '',
  street: '',
  apprehension_region_code: '130000000',
  apprehension_province_code: '133900000',
  apprehension_municipality_code: '',
  apprehension_barangay_code: '',
  apprehension_street: '',
  apprehended_at: '',
  vehicle_type: '',
  vehicle_plate_number: '',
  apprehending_officer_id: '',
  apprehending_officer: '',
  discount: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const VEHICLE_TYPE = [
  { label: 'N/A', value: '' },
  { label: 'BUS', value: 'BUS' },
  { label: 'CAR', value: 'CAR' },
  { label: 'AUV', value: 'AUV' },
  { label: 'JEEPNEY', value: 'JEEPNEY' },
  { label: 'MOTORCYCLE', value: 'MOTORCYCLE' },
  { label: 'TAXI', value: 'TAXI' },
  { label: 'TRAILER', value: 'TRAILER' },
  { label: 'TRICYCLE', value: 'TRICYCLE' },
  { label: 'TRUCK', value: 'TRUCK' },
  { label: 'UTILITY', value: 'UTILITY' },
  { label: 'VAN', value: 'VAN' },
];

export const GET_REGION = 'OVRS/get_regions';
export const GET_PROVINCE = 'OVRS/get_provinces';
export const GET_MUNICIPALITIES = 'OVRS/get_municipalities';
export const GET_BARANGAYS = 'OVRS/get_barangays';

export const GET_APP_REGION = 'OVRS/get_app_regions';
export const GET_APP_PROVINCE = 'OVRS/get_app_provinces';
export const GET_APP_MUNICIPALITIES = 'OVRS/get_app_municipalities';
export const GET_APP_BARANGAYS = 'OVRS/get_app_barangays';

export const TRANSMITTAL = 'api/v1/administrators/ovrs/transmittal/view';
